var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 116.21 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#7da2fe;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#fff;}.cls-1,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-2{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:rgba(255,255,255,.2);}.cls-4{fill:url(#linear-gradient);stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28.19,
    y1: 67.18,
    x2: 49.26,
    y2: 67.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.29,
    y: 18.16,
    width: 85.62,
    height: 90.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.42,35.2h11.42c0,6.27-5.16,11.42-11.42,11.42S1,41.47,1,35.2H12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.26,35.2h11.42c0,6.27-5.16,11.42-11.42,11.42s-11.42-5.16-11.42-11.42h11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.11,35.2h11.42c0,6.27-5.16,11.42-11.42,11.42s-11.42-5.16-11.42-11.42h11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.95,35.2h11.42c0,6.27-5.16,11.42-11.42,11.42s-11.42-5.16-11.42-11.42h11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.79,35.2h11.42c0,6.27-5.16,11.42-11.42,11.42s-11.42-5.16-11.42-11.42h11.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.42 12.05 15.3 12.05 1 35.2 23.84 35.2 32.42 12.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.55 12.05 32.42 12.05 23.84 35.2 46.69 35.2 49.55 12.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "66.67 12.05 49.55 12.05 46.69 35.2 69.53 35.2 66.67 12.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.79 12.05 66.67 12.05 69.53 35.2 92.37 35.2 83.79 12.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.91 12.05 83.79 12.05 92.37 35.2 115.21 35.2 100.91 12.05"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.29,
    y: 0.5,
    width: 85.62,
    height: 11.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 57.78,
    width: 25.13,
    height: 50.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.19,
    y: 57.78,
    width: 21.07,
    height: 18.79
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.d87441642c9184387f96e461c8b12392.svg";
export { ForwardRef as ReactComponent };